import React from 'react';

import Icon, { IconProps } from '@atlaskit/icon';

import { BitkitIconTypes } from '../types';

type Glyph = Required<IconProps>['glyph'];

const glyph = (props: ArgumentsOf<Glyph>[0]) => (
  <svg {...props} width="24" height="24" viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.6831 12C17.2137 12 17.6452 12.4234 17.6566 12.95H17.6586L17.6568 12.9606L17.6569 12.9714C17.6569 13.1132 17.6264 13.2479 17.5716 13.3694C16.9569 15.856 14.7061 17.7 12.0235 17.7C8.86769 17.7 6.30939 15.148 6.30939 12C6.30939 8.85198 8.86769 6.3 12.0235 6.3C13.4045 6.3 14.6711 6.78872 15.659 7.60225L17.1213 6.35193C15.7712 5.13857 13.9838 4.40003 12.0234 4.40003C7.8157 4.40003 4.40464 7.80266 4.40464 12C4.40464 16.1974 7.8157 19.6 12.0234 19.6C15.9087 19.6 19.1147 16.699 19.5833 12.95H19.5852C19.5877 12.4249 20.0153 12 20.5423 12C21.0693 12 21.4968 12.4249 21.4994 12.95H21.5L21.4994 12.9562C21.4993 13.0278 21.4913 13.0976 21.4762 13.1647C20.9005 17.862 16.8879 21.5 12.0235 21.5C6.76382 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.76382 2.5 12.0235 2.5C14.2039 2.5 16.2132 3.23095 17.8185 4.4606L19.2447 5.5276C19.4949 5.71481 19.6423 6.00902 19.6423 6.32153C19.6423 6.60952 19.5171 6.88327 19.2992 7.07162L13.9093 11.7313C13.9217 11.8191 13.9282 11.9088 13.9282 12C13.9282 13.0493 13.0754 13.9 12.0235 13.9C10.9716 13.9 10.1188 13.0493 10.1188 12C10.1188 10.9507 10.9716 10.1 12.0235 10.1C12.2336 10.1 12.4357 10.1339 12.6247 10.1966L14.1798 8.86702C13.5666 8.44629 12.8238 8.20001 12.0234 8.20001C9.91951 8.20001 8.21398 9.90133 8.21398 12C8.21398 14.0987 9.91951 15.8 12.0234 15.8C13.7937 15.8 15.2819 14.5955 15.7094 12.9632C15.7138 12.4305 16.148 12 16.6831 12Z"
      fill="currentColor"
    />
  </svg>
);

export const ScanIcon = (props: BitkitIconTypes): JSX.Element => (
  <Icon {...props} glyph={glyph} />
);
